<!-- 推广账户管理 - 快手 -->
<template>
<div>
	<div style="display: flex;align-items: center;">
		<div v-for="(item,index) in titleTab" :key="index" 
		:class="{'title-tab-box-selected': item.select}" 
		@click="changeTab(item,index)"
		class="title-tab-box">{{item.label}}</div>
	</div>
	
	<div v-show="content_type == 0">
		<ksAccTable></ksAccTable>
	</div>
	
	<div v-show="content_type == 2">
		<ksIDTable></ksIDTable>
	</div>
	
	<div v-show="content_type == 1" style="margin-top: 30px;">
		<ksDevTable></ksDevTable>
	</div>
</div>
</template>

<script>
import ksAccTable from "./KScomponent/ksAccTable"
import ksIDTable from "./KScomponent/ksIDTable"
import ksDevTable from "./KScomponent/ksDevTable"
import { accountKSList } from '@/request/api'
export default {
	name: 'accountKS_',
	components: {
		ksAccTable, ksIDTable, ksDevTable
	},
	data() {
		return {
			titleTab: [
				{label: "推广账户管理", select: true , value: 0 },
				{label: "授权快手ID", select: false , value: 2 },
				{label: "开发者账户管理", select: false , value: 1 },
			],
			content_type: 0, // 页面内容展现类型
		}
	},
	mounted(){
	},
	methods:{
		changeTab(e,index){
			console.log(e);
			// 如果已经是选中状态就没必要再执行一次了
			if(!this.titleTab[index].select){ 
				this.content_type = e.value
				this.titleTab.forEach(res=>{
					res.select = false
				})
				this.titleTab[index].select = true
				
				// this.searchButton('button')
			}
			console.log(this.content_type)
		},
		
	},
}	
</script>

<style scoped>


.class-title {
	width: 100px;
}
</style>